import React, {Component} from "react";
import axios from "axios";
import {ItemTypes} from "./Constant";
import {DragSource} from "react-dnd";
import { Tooltip} from "antd";
import {Icon} from "@ant-design/compatible"
const elementSource = {
  beginDrag: (props, monitor, component) => {
    console.debug("MovingElement beginDrag:", component.state.relativeOffset);
    return {
      elId: props.elId,
      name: props.name,
      type: props.type,
      logo: component.state.logo,
      relativeOffset: component.state.relativeOffset
    }
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  }
}

class MovingElement extends Component {

  state = {
    relativeOffset: "",
    description: "",
    logo: ""
  };

  constructor() {
    super();
    this.onMouseDown = this.onMouseDown.bind(this);
    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount() {
    const { connectDragPreview } = this.props;
    const img = new Image(200, 40);
    img.src = `/api-imagefiles/browse?name=fa43ffd608684a8a9fe82ca276681682.png`;
    img.onload = () => connectDragPreview(img);
    img.width = 200;
    img.height = 40;
    this.fetchData();
  }

  render() {
    const {connectDragSource, isDragging} = this.props;

    return connectDragSource(
      <div style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: "move"
      }}
           onMouseDown={this.onMouseDown}
      >
        {
          isDragging ?
            "拖拽至画板" :
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}>
              <Tooltip title={this.state.description} placement="right">
                <div style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}>
                  {
                    this.props.logo ?
                      <img
                        src={`/api-imagefiles/browse?name=${this.props.logo}`}
                        alt="logo"
                        height="16"
                        width="16"
                        style={{
                          borderRadius: "100%",
                          marginRight: 2
                        }}
                      /> : null
                  }
                  <div>
                    {this.props.name}
                  </div>
                </div>
              </Tooltip>

              <div>
                <Icon type="bars"/>
              </div>
            </div>
        }
      </div>
    )
  }

  onMouseDown(e) {
    const box = e.target.getBoundingClientRect();
    console.debug("Moving Element mouse down => (x, y):", e.clientX - box.left, e.clientY - box.top);
    this.setState({
      relativeOffset: {
        x: e.clientX - box.left,
        y: e.clientY - box.top
      }
    })
  }

  fetchData() {
    let url = "/api-bigdata/datasets/";

    const type = this.props.type.toLowerCase();
    switch(type) {
      case "dataset":
        url = `/api-bigdata/datasets/${this.props.elId}`;
        break;
      case "model":
        url = `/api-bigdata/models/${this.props.elId}`;
        break;
      case "algorithm":
        url = `/api-algorithm/algorithms/${this.props.elId}`;
        break;
      default:
        break;
    }

    axios({
      url: url,
      method: "GET"
    }).then(
      response => {
        this.setState({
          description: response.data.description,
          logo: response.data.logo || "a10f2157404c4d9e80ce02087ac874e7.png"
        })
      }
    ).catch(
      response => {
        this.setState({
          description: "N/A"
        })
      }
    )
  }
}

export default DragSource(ItemTypes.ELEMENT, elementSource, collect)(MovingElement);
